import { render, staticRenderFns } from "./PreloaderWeb.vue?vue&type=template&id=74d713e0&scoped=true&"
import script from "./PreloaderWeb.vue?vue&type=script&lang=js&"
export * from "./PreloaderWeb.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderWeb.vue?vue&type=style&index=0&id=74d713e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d713e0",
  null
  
)

export default component.exports